module.exports = __webpack_public_path__ + "img/stop_severe_bleeding_full.eaa50baa.jpg";